import handleError from '@fuse/core/errorHandler';
import SimpleDialog from '@fuse/core/SimpleDialog/SimpleDialog';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import ProjectStatusForm from './ProjectStatusForm';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Delete, Edit } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import useMessage from 'src/app/hooks/useMessage';
import {
  useDeleteProjectStatusMutation,
  useGetAllProjectStatusesQuery,
} from 'src/app/services/ticket/projectsApi';
import ConfirmDeleteModalWindow from 'app/shared-components/confirmDeleteModalWindow';
import FuseLoading from '@fuse/core/FuseLoading';

const ProjectStatuses = () => {
  const { t, i18n } = useTranslation('translations');
  const [currentStatus, setCurrentStatus] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isOpenedModal, setIsOpenedModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const {
    data: projectStatuses,
    refetch,
    isLoading,
  } = useGetAllProjectStatusesQuery({ lang: i18n.language });
  const [deleteStatus] = useDeleteProjectStatusMutation();
  const { showMessage } = useMessage();

  const showEditDialog = (status) => {
    setCurrentStatus(status);
    setIsDialogOpen(true);
  };

  const showNewItemDialog = () => {
    setCurrentStatus(null);
    setIsDialogOpen(true);
  };

  const handleDelete = (status) => {
    deleteStatus({ id: status.id, ...status })
      .unwrap()
      .then(() => {
        showMessage({ message: t('ProjectStatusSuccessfullyDeleted'), variant: 'success' });
        refetch();
      })
      .catch(handleError);
  };

  const handleShowModal = (status) => {
    setSelected(status);
    setIsOpenedModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenedModal(false);
  };

  return (
    <div style={{ display: 'grid' }}>
      {isLoading ? (
        <FuseLoading />
      ) : (
        <TableContainer>
          <div className="h-[40px] flex flex-row justify-between items-center dark:bg-dark">
            <h2 className="ml-5"> {t('ProjectStatuses')}</h2>
            <Button
              className="mx-8"
              size="small"
              variant="outlined"
              color="secondary"
              onClick={showNewItemDialog}
            >
              <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
              <span className="mx-8">{t('Add')}</span>
            </Button>
          </div>
          <Table style={{ overflow: 'auto' }}>
            <TableHead>
              <TableRow className="dark:bg-dark">
                <TableCell>{t('Title') + ' (uz)'}</TableCell>
                <TableCell>{t('Title') + ' (рус)'}</TableCell>
                <TableCell>{t('Actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className=" overflow-y-auto">
              {projectStatuses &&
                projectStatuses?.map((status) => (
                  <TableRow key={status.id} className="bg-white dark:bg-dark hover:bg-grey-200">
                    <TableCell>{status.nameUz}</TableCell>
                    <TableCell>{status.nameRu}</TableCell>
                    <TableCell>
                      <div className="flex">
                        <IconButton
                          edge="end"
                          aria-label="edit"
                          className="mr-5"
                          color="info"
                          onClick={() => showEditDialog(status)}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          onClick={() => handleShowModal(status)}
                          className="mr-10"
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <SimpleDialog
            title={currentStatus ? t('EditProjectStatus') : t('AddProjectStatus')}
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
          >
            <ProjectStatusForm
              projectStatus={currentStatus}
              refetch={refetch}
              onClose={() => setIsDialogOpen(false)}
              isEdit={currentStatus ? true : false}
            />
          </SimpleDialog>
        </TableContainer>
      )}
      {isOpenedModal && (
        <ConfirmDeleteModalWindow
          onClose={handleCloseModal}
          setIsOpenModal={setIsOpenedModal}
          modalTitle={'AreYouSureToDeleteProjectStatus'}
          deleteMessage={() => handleDelete(selected)}
          open={isOpenedModal}
        />
      )}
    </div>
  );
};

export default ProjectStatuses;
